define('app-Loader/main',['../app/ui/dialog'], function (dialog) {
    var currentDialog = null;

    return {
        show: function (text) {

            if (currentDialog && currentDialog.isOpen()) {
                currentDialog.changeTitle(text || "");
            } else {
                currentDialog = dialog.show(text || "", null, { noClose: true, width: "80%" }, false, ['loader']);
            }
        },

        hide: function () {
            var loadingContainer = $("#loadingContainer");
            if (loadingContainer.length > 0) {
                loadingContainer.fadeOut();
            }
            if (currentDialog) {
                currentDialog.close();
                currentDialog = null;
            }
            else {
                dialog.closeAll();
            }
        },

        run: function () {
            window.loadedModules("Loader");
        }
    }
});
